import { Status } from 'src/app/modules/shared/models/status';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'activityBy', pure: true })
export class ActivityByPipe implements PipeTransform {

    transform(activityDetails: any): any {

        let by = "by";
        let via = "";

        if(activityDetails?.description?.length>0){
            const viaList: string[] = activityDetails?.description.split(/\b(?:via)\b/i);
            if(viaList?.length>1 && viaList[1]?.trim()){
                via = ` via ${viaList[1].trim()} `
            }
        }

        if(['ActiveInactiveAccountLog','ActiveInactiveLeadLog','ActiveInactiveContactLog','ActiveInactiveOpportunityLog'].includes(activityDetails?.type)){
            let statusBy = activityDetails?.objectData?.status?.name;

            switch (activityDetails?.objectData?.status?.id) {
                case Status.Active:
                    by = 'Activated'+via+' by';
                    break;
                case Status.InActive:
                    by = 'Inactivated'+via+' by';
                    break;
                case Status.Deleted:
                    by = 'Deleted'+via+' by';
                    break;
                default:
                    by = statusBy+' by';
                    break;
            }

            return by;
        }

        if(activityDetails?.objectData && activityDetails?.objectData?.action){

            switch (activityDetails.objectData.action) {
                case 'Insert':
                case 'Create':
                    by = 'Created'+via+' by';
                    break;
                case 'Update':
                case 'ApprovalFromWF':
                case 'Approve/Decline':
                    by = 'Updated'+via+' by';
                    break;
                case 'Delete':
                    by = 'Deleted'+via+' by';
                    break;
                default:
                    by = 'by';
                    break;
            }

            if(!activityDetails?.type && activityDetails?.objectData?.objectId==21){
                by = `Task ${by}`;
            }

            return by;
        }

        return "by";
    }

 }
